<template>
  <div id="badge">
    <top></top>
    <div class="main">
      <!-- 左侧菜单 -->
      <navMenu :active="active"></navMenu>
      <!-- 右侧内容区域 -->
      <div class="content" v-loading="loading">
        <div class="go-back" @click="back">
          {{ language === "cn" ? "返回" : "Back" }}
        </div>
        <div class="content-main">
          <div class="main-title">
            {{ language === "cn" ? "展商胸卡" : "Exhibiton Badge" }}
          </div>
          <p class="main-subtitle">
            {{
              language === "cn"
                ? "展商胸卡（截止日期：2025年8月25日，之后填写的将无法制作）"
                : "Deadline: August 25th, 2025. Submissions after this date cannot be processed."
            }}
          </p>
          <p class="main-rule">
            {{
              language === "cn"
                ? "·展会实行参展商胸卡实名制"
                : "·The Congress implements a real-name policy for exhibitor badges."
            }}
          </p>
          <p class="main-rule">
            {{
              language === "cn"
                ? "·根据展馆相关规定，所有进入展览场馆的人员需实名登记身份信息，因此请您填写准确的个人身份信息"
                : "·Per venue regulations, all persons entering the exhibition area must register with verified identification. Please provide accurate personal information."
            }}
          </p>
          <p class="main-rule" style="margin-bottom: 20px">
            {{
              language === "cn"
                ? "·参展商可免费申请胸卡，数量为4张/9平米（此处为9平米倍数，每增加9平米则数量增加4张，总面积不足9平米按9平米计算）"
                : "·Exhibitors can apply for badges free of charge at a ratio of 4 badges/9㎡ (rounded up - each additional 9㎡ grants 4 more badges)."
            }}
          </p>
          <p class="main-reload">
            {{
              language === "cn"
                ? "胸卡信息提交后，为在列表中显示，请刷新页面。"
                : "After submission, refresh the page to display updated badge information in the list."
            }}
          </p>
          <!-- <p class="main-tips">重要提示：</p>
          <p class="main-tips">
            1、往届胸卡信息需重新确认，请逐个勾选需要设置为本届参展商信息，并点击列表下方的“批量设定参展商”，同一人员无需重复设置参展商
          </p>
          <p class="main-tips">
            2、当本届参展商状态栏内，显示为“<i
              style="font-size: 20px; color: #52c41a; font-weight: bold"
              class="el-icon-check"
            ></i
            >”时，即为设置成功
          </p> -->
        </div>
        <div class="content-number">
          <p>
            {{
              language === "cn" ? "展商胸卡列表" : "Exhibitor Badge List"
            }}（{{ currentBadgeCount }}/{{ theMostBadgeCount }}）
          </p>
          <div v-if="showButton">
            <div v-if="showImportButton">
              {{
                language === "cn" ? "上传导入模版" : "Upload Import Template"
              }}
              <el-upload
                class="content-uploader"
                :action="$fileUrlImportBadge"
                :headers="headers"
                :data="{
                  mark: mark,
                }"
                :multiple="false"
                :show-file-list="false"
                :on-success="handleUploadFileSuccess"
                :before-upload="handleBeforeFileUplpad"
              ></el-upload>
            </div>
            <div @click="downloadImportTemplate" v-if="showImportButton">
              {{
                language === "cn"
                  ? "下载批量导入模版"
                  : "Download Batch Import Template"
              }}
            </div>
            <div @click="viewBadgeDetail('create')">
              {{
                language === "cn" ? "创建展商胸卡" : "Create Exhibitor Badges"
              }}
            </div>
          </div>
        </div>
        <div class="content-main" style="display: flex">
          <div class="main-form">
            <p>{{ language === "cn" ? "本届参展商" : "Current Exhibitor" }}</p>
            <el-select
              v-model="searchValue.isThisSessionsExhibitor"
              :placeholder="language === 'cn' ? '请选择' : 'Select'"
            >
              <el-option
                v-for="item in this_sessions_exhibitor_options"
                :key="item.value"
                :label="language === 'cn' ? item.name : item.name_en"
                :value="item.value"
              >
              </el-option>
            </el-select>
          </div>
          <div class="main-form">
            <p>{{ language === "cn" ? "姓名" : "Name" }}</p>
            <el-input
              v-model="searchValue.userName"
              :placeholder="language === 'cn' ? '请输入内容' : 'Enter text'"
            ></el-input>
          </div>
          <div class="main-form">
            <p>{{ language === "cn" ? "手机号" : "Mobile" }}</p>
            <el-input
              v-model="searchValue.userTel"
              :placeholder="language === 'cn' ? '请输入内容' : 'Enter text'"
            ></el-input>
          </div>
          <div class="main-button" @click="handleSearchBadge">
            {{ language === "cn" ? "搜索" : "Search" }}
          </div>
        </div>
        <div class="content-main">
          <el-table
            :data="badgeTableData"
            style="width: 100%"
            @selection-change="handleTableSelectionChange"
            :empty-text="language === 'cn' ? '暂无数据' : 'No Records Found'"
          >
            <el-table-column type="selection" min-width="50"></el-table-column>
            <el-table-column prop="id" label="ID" min-width="80">
            </el-table-column>
            <el-table-column
              :label="language === 'cn' ? '本届参展商' : 'Current Exhibitor'"
              min-width="100"
            >
              <template slot-scope="scope">
                <i
                  class="el-icon-check"
                  style="font-weight: 700; font-size: 24px; color: #52c41a"
                  v-if="scope.row.is_exhibitor == 1"
                ></i>
                <i
                  class="el-icon-close"
                  style="font-weight: 700; font-size: 24px; color: #eb4141"
                  v-else
                ></i>
              </template>
            </el-table-column>
            <el-table-column
              prop="nickname"
              :label="language === 'cn' ? '姓名' : 'Name'"
              min-width="80"
            >
            </el-table-column>
            <el-table-column
              prop="card_type_name"
              :label="language === 'cn' ? '证件类型' : 'ID Type'"
              min-width="150"
            >
            </el-table-column>
            <el-table-column
              prop="country_name"
              :label="language === 'cn' ? '国家/地区' : 'Country/Region'"
              min-width="130"
            >
            </el-table-column>
            <el-table-column
              prop="id_number"
              :label="language === 'cn' ? '证件号' : 'ID Number'"
              min-width="150"
            >
            </el-table-column>
            <el-table-column
              prop="department"
              :label="language === 'cn' ? '部门' : 'Department'"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              prop="position"
              :label="language === 'cn' ? '职位' : 'Position'"
              min-width="100"
            >
            </el-table-column>
            <el-table-column
              prop="tel"
              :label="language === 'cn' ? '手机号' : 'Mobile'"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              prop="email"
              :label="language === 'cn' ? '电子邮箱' : 'Email'"
              min-width="180"
            >
            </el-table-column>
            <el-table-column
              prop="create_time"
              :label="language === 'cn' ? '添加时间' : 'Creation Time'"
              min-width="120"
            >
            </el-table-column>
            <el-table-column
              :label="language === 'cn' ? '操作' : 'Actions'"
              min-width="60"
            >
              <template slot-scope="scope">
                <div
                  style="color: #3d83e9; cursor: pointer; font-weight: 500"
                  @click="viewBadgeDetail('edit', scope.row)"
                >
                  {{ language === "cn" ? "查看" : "view" }}
                </div>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="content-footer">
          <div class="content-footer-button" v-if="showButton">
            <div @click="handleBatchOperation('is_exhibitor', 1)">
              {{
                language === "cn"
                  ? "批量设定本届参展商"
                  : "Batch Set Current Exhibitors"
              }}
            </div>
            <div @click="handleBatchOperation('is_exhibitor', 0)">
              {{
                language === "cn"
                  ? "批量取消本届参展商"
                  : "Batch Cancel Current Exhibitors"
              }}
            </div>
            <div @click="handleBatchDeleteBadge">
              {{ language === "cn" ? "批量删除" : "Batch Delete" }}
            </div>
          </div>
          <div class="content-footer-paging">
            <el-pagination
              background
              layout="prev, pager, next"
              :total="total"
              :page-size="pageSize"
              :current-page="pageNumber"
              @current-change="handleCurrentPageChange"
            >
            </el-pagination>
          </div>
        </div>
        <el-dialog
          :title="dialogTitle"
          :visible.sync="showDialog"
          :close-on-click-modal="false"
          @close="handleCloseDialog"
          width="50%"
        >
          <el-form
            :model="badgeForm"
            :rules="badgeRules"
            ref="badgeRef"
            label-position="right"
            label-width="140px"
          >
            <el-form-item
              :label="language === 'cn' ? '姓名：' : 'Name:'"
              prop="nickname"
            >
              <el-input v-model="badgeForm.nickname"></el-input>
            </el-form-item>
            <el-form-item
              :label="language === 'cn' ? '证件类型：' : 'ID Type:'"
              prop="card_type"
            >
              <el-select
                v-model="badgeForm.card_type"
                :placeholder="language === 'cn' ? '请选择' : 'Select'"
                @change="handleSelectCertificateType"
              >
                <el-option
                  v-for="item in certificate_type_options"
                  :key="item.value"
                  :label="language === 'cn' ? item.name : item.name_en"
                  :value="item.value"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="language === 'cn' ? '国家地区：' : 'Country/Region:'"
              prop="country"
            >
              <el-select
                v-model="badgeForm.country"
                :disabled="badgeForm.card_type !== '港澳通行证'"
                :placeholder="language === 'cn' ? '请选择' : 'Select'"
              >
                <el-option
                  v-for="item in country_region_options"
                  :key="item.value"
                  :label="language === 'cn' ? item.name : item.name_en"
                  :value="item.value"
                  :disabled="item.disabled"
                >
                </el-option>
              </el-select>
            </el-form-item>
            <el-form-item
              :label="language === 'cn' ? '证件号码：' : 'ID Number:'"
              prop="id_number"
            >
              <el-input v-model="badgeForm.id_number"></el-input>
            </el-form-item>
            <el-form-item
              :label="language === 'cn' ? '部门：' : 'Department:'"
              prop="department"
            >
              <el-input v-model="badgeForm.department"></el-input>
            </el-form-item>
            <el-form-item
              :label="language === 'cn' ? '职位：' : 'Position:'"
              prop="position"
            >
              <el-input v-model="badgeForm.position"></el-input>
            </el-form-item>
            <el-form-item
              :label="language === 'cn' ? '手机：' : 'Mobile:'"
              prop="tel"
            >
              <el-input v-model="badgeForm.tel"></el-input>
            </el-form-item>
            <el-form-item
              :label="language === 'cn' ? '电子邮箱：' : 'Email:'"
              prop="email"
            >
              <el-input v-model="badgeForm.email"></el-input>
            </el-form-item>
          </el-form>
          <div class="dialog-button">
            <div class="cancel" @click="handleCloseDialog">
              {{ language === "cn" ? "取 消" : "Cancel" }}
            </div>
            <div class="confirm" @click="verifyForm">
              {{ language === "cn" ? "确 定" : "Confirm" }}
            </div>
          </div>
        </el-dialog>
      </div>
    </div>
  </div>
</template>
<script>
import top from "../components/top.vue"; //头部
import navMenu from "../components/navMenu.vue"; //左侧步骤条
import {
  getDictionary,
  badgeList,
  addBadge,
  editBadge,
  updBoolean,
  batchDeleteBadge,
} from "../api/api";
export default {
  components: { top, navMenu },
  name: "badge",
  data() {
    const checkTelephoneNumber = (rule, value, callback) => {
      if (this.badgeForm.card_type != "居民身份证") {
        if (value == "") {
          callback(
            new Error("请输入手机号/Please Enter The Mobile Phone Number")
          );
        } else {
          callback();
        }
      } else {
        const reg = /^1[3-9]\d{9}$/;
        if (value == "") {
          callback(
            new Error("请输入手机号/Please Enter The Mobile Phone Number")
          );
        } else if (!reg.test(value)) {
          callback(
            new Error(
              "手机号码格式不正确/Mobile Phone Number Format Is Incorrect"
            )
          );
        } else {
          callback();
        }
      }
    };
    const checkEmail = (rule, value, callback) => {
      const reg = /^[a-zA-Z0-9._%+-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/;
      if (value == "") {
        callback(new Error("请输入电子邮箱 / Please Enter The Email"));
      } else if (!reg.test(value)) {
        callback(new Error("电子邮箱格式不正确 / Email Format Is Incorrect"));
      } else {
        callback();
      }
    };
    return {
      loading: false,
      stepMenuList: [],
      detail: "",
      active: "",
      mark: "",
      language: "",
      headers: {},
      searchValue: {
        isThisSessionsExhibitor: "",
        userName: "",
        userTel: "",
      },
      pageNumber: 1,
      pageSize: 10,
      total: 0,
      this_sessions_exhibitor_options: [],
      certificate_type_options: [],
      country_region_options: [],
      badgeTableData: [],
      currentBadgeCount: "",
      theMostBadgeCount: "",
      selectedTableData: [],
      showDialog: false,
      dialogTitle: "",
      badgeForm: {
        nickname: "",
        card_type: "",
        country: "",
        id_number: "",
        department: "",
        position: "",
        tel: "",
        email: "",
      },
      badgeRules: {
        nickname: [
          {
            required: true,
            message: "请输入姓名 / Please Enter The Name",
            trigger: "blur",
          },
        ],
        card_type: [
          {
            required: true,
            message: "请选择证件类型 / Please Select The ID Type",
            trigger: "blur",
          },
        ],
        country: [
          {
            required: true,
            message: "请选择国家地区 / Please Select The Country & Region",
            trigger: "blur",
          },
        ],
        id_number: [
          {
            required: true,
            message: "请输入证件号 / Please Enter The ID Number",
            trigger: "blur",
          },
        ],
        department: [
          {
            required: true,
            message: "请输入部门 / Please Enter The Department",
            trigger: "blur",
          },
        ],
        position: [
          {
            required: true,
            message: "请输入职位 / Please Enter The Position",
            trigger: "blur",
          },
        ],
        tel: [
          {
            required: true,
            validator: checkTelephoneNumber,
            trigger: "blur",
          },
        ],
        email: [
          {
            required: true,
            validator: checkEmail,
            trigger: "blur",
          },
        ],
      },
      showButton: false,
      showImportButton: false,
    };
  },
  created() {
    let stepMenuList = JSON.parse(localStorage.getItem("menu"));
    this.stepMenuList = stepMenuList;
    var index = stepMenuList.findIndex(function (item) {
      return item.link_url == "/conference" && item.id == 38;
    });
    this.detail = stepMenuList[index];
    this.mark = this.detail.children[0].mark;
    this.active = index;
    this.language = localStorage.getItem("language");
    this.headers = {
      token: localStorage.getItem("token"),
    };
    this.getDictionaryData();
  },
  methods: {
    async getDictionaryData() {
      const res = await getDictionary(
        "type=show_type,badge_card_type,badge_country"
      );
      if (res.data.code == 1) {
        this.this_sessions_exhibitor_options = res.data.data.show_type;
        this.certificate_type_options = res.data.data.badge_card_type;
        this.country_region_options = res.data.data.badge_country;
        this.country_region_options.forEach((item) => {
          if (item.value === "中国香港" || item.value === "中国澳门") {
            item.disabled = false;
          } else {
            item.disabled = true;
          }
        });
        this.getBadgeList();
      } else {
        if (this.language === "cn") {
          this.this.$message.error("获取字典数据失败");
        } else {
          this.$message.error("Failed to fetch dictionary data");
        }
      }
    },
    async getBadgeList() {
      let data = {
        is_exhibitor: this.searchValue.isThisSessionsExhibitor,
        nickname: this.searchValue.userName,
        tel: this.searchValue.userTel,
        page_no: this.pageNumber,
        page_size: this.pageSize,
      };
      const res = await badgeList(this.$qs.stringify(data));
      if (res.data.code == 1) {
        this.showButton = res.data.data.badge_btn_display;
        this.showImportButton = res.data.data.import_btn_display;
        this.currentBadgeCount = res.data.data.badgeCount;
        this.theMostBadgeCount = res.data.data.badge_num;
        this.pageNumber = res.data.data.page_no;
        this.pageSize = res.data.data.page_size;
        this.total = res.data.data.count;
        res.data.data.lists.forEach((item) => {
          for (let i = 0; i < this.certificate_type_options.length; i++) {
            if (this.certificate_type_options[i].value === item.card_type) {
              if (this.language === "cn") {
                item.card_type_name = this.certificate_type_options[i].name;
              } else {
                item.card_type_name = this.certificate_type_options[i].name_en;
              }
            }
          }
          for (let j = 0; j < this.country_region_options.length; j++) {
            if (this.country_region_options[j].value === item.country) {
              if (this.language === "cn") {
                item.country_name = this.country_region_options[j].name;
              } else {
                item.country_name = this.country_region_options[j].name_en;
              }
            }
          }
        });
        this.badgeTableData = res.data.data.lists;
      } else {
        if (this.language === "cn") {
          this.this.$message.error("获取胸卡列表失败");
        } else {
          this.$message.error("Failed to fetch badge list");
        }
      }
    },
    handleSearchBadge() {
      this.pageNumber = 1;
      this.getBadgeList();
    },
    viewBadgeDetail(title, data) {
      if (title === "create") {
        if (this.language === "cn") {
          this.dialogTitle = "创建展商胸卡";
        } else {
          this.dialogTitle = "Create Exhibitor Badge";
        }
      } else if (title === "edit") {
        if (this.language === "cn") {
          this.dialogTitle = "编辑展商胸卡";
        } else {
          this.dialogTitle = "Edit Exhibitor Badge";
        }

        this.badgeForm = {
          nickname: data.nickname,
          card_type: data.card_type,
          country: data.country !== "" ? data.country : "",
          id_number: data.id_number,
          department: data.department,
          position: data.position,
          tel: data.tel,
          email: data.email,
          badge_long_id: data.badge_long_id,
        };
        this.handleSelectCertificateType(data.card_type);
      }
      this.showDialog = true;
    },
    handleSelectCertificateType(val) {
      if (this.language === "cn") {
        if (val === "居民身份证") {
          this.badgeForm.country = "中国大陆";
        } else if (val === "护照") {
          this.badgeForm.country = "其他国家或地区";
        } else if (val === "港澳通行证") {
          if (
            this.badgeForm.country !== "中国香港" &&
            this.badgeForm.country !== "中国澳门"
          ) {
            this.badgeForm.country = "";
          }
        } else if (val === "台湾居住来往大陆通行证") {
          this.badgeForm.country = "中国台湾";
        }
      } else if (this.language === "en") {
        if (val === "居民身份证") {
          this.badgeForm.country = "中国大陆";
        } else if (val === "护照") {
          this.badgeForm.country = "其他国家或地区";
        } else if (val === "港澳通行证") {
          if (
            this.badgeForm.country !== "中国香港" &&
            this.badgeForm.country !== "中国澳门"
          ) {
            this.badgeForm.country = "";
          }
        } else if (val === "台湾居住来往大陆通行证") {
          this.badgeForm.country = "中国台湾";
        }
      }
    },
    verifyForm() {
      let obj = {};
      if (this.language === "cn") {
        obj.content = "请问您是否确认要提交?";
        obj.tips = "确认提交";
        obj.comfirm = "确定";
        obj.cancel = "取消";
      } else {
        obj.content = "Are you sure you want to submit?";
        obj.tips = "Confirm Submission";
        obj.comfirm = "Confirm";
        obj.cancel = "Cancel";
      }
      this.$confirm(obj.content, obj.tips, {
        confirmButtonText: obj.comfirm,
        cancelButtonText: obj.cancel,
        type: "warning",
      })
        .then(() => {
          let arr = [];
          Object.keys(this.$refs).forEach((item) => {
            arr.push(this.checkForm(item));
          });
          Promise.all(arr)
            .then(() => {
              this.submitForm();
            })
            .catch((error) => {
              this.$message.error(error.trim());
            });
        })
        .catch(() => {});
    },
    checkForm(formName) {
      return new Promise((resolve, reject) => {
        this.$refs[formName].validate((valid, field) => {
          if (valid) {
            resolve();
          } else {
            let firstFailField = Object.keys(field)[0];
            let firstFailFieldMessage =
              field[firstFailField][0].message.split("/");
            let backMessage = "";
            if (this.language === "cn") {
              backMessage = firstFailFieldMessage[0];
            } else {
              backMessage =
                firstFailFieldMessage[firstFailFieldMessage.length - 1];
            }
            reject(backMessage);
          }
        });
      });
    },
    submitForm() {
      if (
        this.dialogTitle === "编辑展商胸卡" ||
        this.dialogTitle === "Edit Exhibitor Badge"
      ) {
        this.handleEditBadge();
      } else {
        this.handleCreateBadge();
      }
    },
    async handleCreateBadge() {
      let data = this.badgeForm;
      data.mark = this.mark;
      const res = await addBadge(data);
      if (res.data.code == 1) {
        if (this.language == "cn") {
          this.$message.success("创建成功");
        } else {
          this.$message.success("Successfully created");
        }
        this.pageNumber = 1;
        this.showDialog = false;
        this.badgeForm = {};
        this.getBadgeList();
      } else {
        if (this.language === "cn") {
          this.$message.error("创建展商胸卡失败！");
        } else {
          this.$message.error("Failed to create exhibitor badge");
        }
      }
    },
    async handleEditBadge() {
      let data = this.badgeForm;
      data.mark = this.mark;
      const res = await editBadge(data);
      if (res.data.code == "1") {
        if (this.language == "cn") {
          this.$message.info(res.data.msg);
        } else {
          this.$message.error("Successfully edited");
        }
        this.pageNumber = 1;
        this.showDialog = false;
        this.badgeForm = {};
        this.getBadgeList();
      } else {
        if (this.language == "cn") {
          this.$message.error("编辑失败！");
        } else {
          this.$message.error("Failed to edit!");
        }
      }
    },
    handleCloseDialog() {
      this.showDialog = false;
      this.badgeForm = {};
    },
    handleCurrentPageChange(val) {
      this.pageNumber = val;
      this.getBadgeList();
    },
    handleTableSelectionChange(val) {
      this.selectedTableData = val;
    },
    async handleBatchOperation(type, val) {
      let arr = this.selectedTableData;
      if (arr.length == 0) {
        if (this.language == "cn") {
          this.$message.warning("您还未选择任何人员");
        } else {
          this.$message.warning("No personnel have been selected yet!");
        }
        return false;
      }
      let ids = [];
      arr.forEach((item) => {
        ids.push(item.badge_long_id);
      });
      let data = {
        field: type,
        val,
        ids: ids.join(","),
        mark: this.mark,
      };
      const res = await updBoolean(data);
      if (res.data.code == 1) {
        if (this.language === "cn") {
          this.$message.success(res.data.msg);
        } else {
          this.$message.success("Successfully set");
        }
        this.getBadgeList();
      } else {
        if (this.language === "cn") {
          this.$message.error(res.data.msg);
        } else {
          this.$message.error("Failed to set");
        }
      }
    },
    handleBatchDeleteBadge() {
      let arr = this.selectedTableData;
      if (arr.length == 0) {
        if (this.language == "cn") {
          this.$message.warning("您还未选择任何人员");
        } else {
          this.$message.warning("No personnel have been selected yet!");
        }
        return false;
      }
      let obj = {};
      if (this.language === "cn") {
        obj.content = "请问您是否确认要删除这些胸卡?";
        obj.tips = "删除";
        obj.comfirm = "确定";
        obj.cancel = "取消";
      } else {
        obj.content = "Are you sure you want to delete these badges?";
        obj.tips = "Delete Badge";
        obj.comfirm = "Confirm";
        obj.cancel = "Cancel";
      }
      this.$confirm(obj.content, obj.tips, {
        confirmButtonText: obj.comfirm,
        cancelButtonText: obj.cancel,
        type: "warning",
      }).then(async () => {
        let ids = [];
        arr.forEach((item) => {
          ids.push(item.badge_long_id);
        });
        let data = {
          badge_long_ids: ids.join(","),
          mark: this.mark,
        };
        const res = await batchDeleteBadge(data);
        if (res.data.code == 1) {
          if (this.language === "cn") {
            this.$message.success(res.data.msg);
          } else {
            this.$message.success("Successfully delete");
          }
          this.getBadgeList();
        } else {
          if (this.language === "cn") {
            this.$message.error(res.data.msg);
          } else {
            this.$message.error("Failed to delete");
          }
        }
      });
    },
    handleBeforeFileUplpad(file) {
      this.loading = true;
      if (file.type !== "application/vnd.ms-excel") {
        this.$message.error(
          this.language === "cn"
            ? "只允许上传.xls后缀的文件"
            : "Only .xls files are allowed for upload."
        );
        this.loading = false;
        return false;
      }
    },
    handleUploadFileSuccess(res) {
      this.loading = false;
      let message = "";
      if (res.code == 1) {
        message = res.data.msg;
      } else if (res.code == 0) {
        let arr1 = [];
        let arr2 = [];
        let tempArray = [];
        let resultArray = [];
        tempArray = res.data.msg.split("#");
        arr1.push(tempArray[0]);
        arr2 = tempArray[1].split(",");
        resultArray = arr1.concat(arr2);
        resultArray.forEach((item, index) => {
          if (index === resultArray.length - 1) {
            message += `<div>${item}</div>`;
          } else {
            message += `<div style="margin-bottom: 12px;">${item}</div>`;
          }
        });
      }
      this.$message({
        message,
        dangerouslyUseHTMLString: true,
        type: res.code == 1 ? "success" : "error",
        duration: 3000,
      });
      this.getBadgeList();
    },
    downloadImportTemplate() {
      let url =
        "https://oss.chinadentalshow.com/uploads/exhibitorUp/badge/%E5%8F%82%E5%B1%95%E5%95%86%E8%83%B8%E5%8D%A1%E7%94%B3%E8%AF%B7%E5%AF%BC%E5%85%A5%E7%A4%BA%E4%BE%8B.xls";
      fetch(url)
        .then((response) => {
          if (!response.ok) {
            this.$message.error(
              this.language === "cn"
                ? "网络响应异常，请检查网络"
                : "Network error. Check your network"
            );
          }
          return response.blob();
        })
        .then((blob) => {
          // 创建临时链接
          const link = document.createElement("a");
          const objectURL = URL.createObjectURL(blob);
          // 设置下载属性
          link.href = objectURL;
          link.download =
            this.language === "cn" ? "导入模版" : "Import Template"; // 自定义文件名
          link.style.display = "none";
          // 触发下载
          document.body.appendChild(link);
          link.click();
          this.$message.success(
            this.language === "cn" ? "下载成功！" : "Download successful"
          );
          // 清理资源
          document.body.removeChild(link);
          URL.revokeObjectURL(objectURL);
        })
        .catch((error) => {
          this.$message.error(
            this.language === "cn" ? "下载失败" : "Download failed"
          );
        });
    },
    back() {
      this.$router.back();
    },
  },
};
</script>
<style lang="scss" scoped>
.content-main {
  background-color: #fff;
  margin-top: 20px;
  border-radius: 8px;
  box-sizing: border-box;
  padding: 30px 20px 30px;
  align-items: flex-end;
  .main-title {
    margin-bottom: 16px;
  }
  .main-subtitle {
    color: #354052;
    margin-bottom: 40px;
    font-weight: 500;
  }
  .main-rule {
    color: #1d1d1d;
    font-size: 14px;
    margin-bottom: 8px;
  }
  .main-reload {
    color: #1d1d1d;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .main-tips {
    color: #ff4d4f;
    font-size: 14px;
    margin-bottom: 8px;
  }
  .main-tips:last-child {
    margin-bottom: 0;
  }
  .main-form {
    width: 20%;
    margin-right: 3%;
    p {
      color: #7f8fa4;
      font-size: 14px;
      margin-bottom: 12px;
    }
    /deep/ .el-select {
      width: 100%;
    }
  }
  .main-button {
    width: 104px;
    height: 40px;
    color: #fff;
    text-align: center;
    line-height: 40px;
    background: #fc933f;
    border-radius: 4px;
    cursor: pointer;
    font-size: 14px;
    font-weight: 500;
  }
  .main-button:hover {
    opacity: 0.9;
  }
}
.content-number {
  margin: 20px 0 30px;
  color: #354052;
  font-weight: 500;
  display: flex;
  justify-content: space-between;
  > div {
    display: flex;
    > div {
      font-weight: 500;
      color: #fff;
      font-size: 14px;
      background: linear-gradient(270deg, #fe4d34 0%, #fc933f 100%);
      border-radius: 4px;
      margin-left: 12px;
      cursor: pointer;
      line-height: 36px;
      height: 36px;
      padding: 0 10px;
      text-align: center;
      position: relative;
      /deep/ .content-uploader {
        position: absolute;
        width: 100%;
        height: 100%;
        top: 0;
        left: 0;
        .el-upload {
          width: 100%;
          height: 100%;
        }
      }
    }
    div:hover {
      opacity: 0.9;
    }
  }
}
.content-footer {
  margin-top: 60px;
  display: flex;
  justify-content: space-between;
  .content-footer-button {
    display: flex;
    div {
      background-color: #3d83e9;
      padding: 8px 12px;
      border-radius: 4px;
      margin-right: 10px;
      color: #fff;
      font-size: 14px;
      font-weight: 500;
      cursor: pointer;
    }
    div:hover {
      opacity: 0.8;
    }
  }
}
/deep/ .el-dialog {
  border-radius: 12px;
  .el-form {
    padding: 0 30px;
    .el-input {
      width: 80%;
    }
    .el-select {
      width: 80%;
      .el-input {
        width: 100%;
      }
    }
  }
  .dialog-button {
    display: flex;
    justify-content: flex-end;
    align-items: center;
    margin-top: 40px;
    margin-right: 20px;
    div {
      width: 72px;
      height: 38px;
      text-align: center;
      line-height: 38px;
      font-size: 14px;
      box-sizing: border-box;
      border: 1px solid #dcdfe6;
      border-radius: 4px;
      font-weight: 500;
      cursor: pointer;
    }
    .confirm {
      margin-left: 10px;
      background-color: #409eef;
      color: #fff;
      border: none;
    }
    .confirm:hover {
      opacity: 0.8;
    }
    .cancel:hover {
      color: #409eef;
      border-color: #c6e2ff;
      background-color: #ecf5ff;
    }
  }
}
</style>